import { render, staticRenderFns } from "./HideSidebarButton.vue?vue&type=template&id=33b06429&scoped=true&"
import script from "./HideSidebarButton.vue?vue&type=script&lang=js&"
export * from "./HideSidebarButton.vue?vue&type=script&lang=js&"
import style0 from "./HideSidebarButton.vue?vue&type=style&index=0&id=33b06429&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b06429",
  null
  
)

export default component.exports